import { defineRouting } from 'next-intl/routing'
import { createNavigation } from 'next-intl/navigation'

export const locales = ['de', 'en'] as const

export type Locale = (typeof locales)[number]

export const routing = defineRouting({
  // A list of all locales that are supported
  locales,

  // Used when no locale matches
  defaultLocale: 'de',

  localePrefix: 'as-needed',
  localeDetection: false,

  pathnames: {
    '/': '/',
    '/[slug]': '/[slug]',
    '/blog': '/blog',
    '/blog/[slug]': '/blog/[slug]',
    '/kontakt': {
      de: '/kontakt',
      en: '/contact',
    },
    '/ueber-uns': {
      de: '/ueber-uns',
      en: '/about-us',
    },
    '/ueber-uns/llms.txt': {
      de: '/ueber-uns/llms.txt',
      en: '/about-us/llms.txt',
    },
    '/ueber-uns/arbeitsweise': {
      de: '/ueber-uns/arbeitsweise',
      en: '/about-us/operation',
    },
    '/ueber-uns/engagement': {
      de: '/ueber-uns/engagement',
      en: '/about-us/commitment',
    },
    '/ueber-uns/[slug]': {
      de: '/ueber-uns/[slug]',
      en: '/about-us/[slug]',
    },
    '/projekte': {
      de: '/projekte',
      en: '/projects',
    },
    '/projekte/llms.txt': {
      de: '/projekte/llms.txt',
      en: '/projects/llms.txt',
    },
    '/projekte/[slug]': {
      de: '/projekte/[slug]',
      en: '/projects/[slug]',
    },
    '/projekte/[slug]/llms.txt': {
      de: '/projekte/[slug]/llms.txt',
      en: '/projects/[slug]/llms.txt',
    },
    '/kompetenzen': {
      de: '/kompetenzen',
      en: '/expertise',
    },
    '/kompetenzen/llms.txt': {
      de: '/kompetenzen/llms.txt',
      en: '/expertise/llms.txt',
    },
    '/kompetenzen/[slug]': {
      de: '/kompetenzen/[slug]',
      en: '/expertise/[slug]',
    },
    '/kompetenzen/[slug]/llms.txt': {
      de: '/kompetenzen/[slug]/llms.txt',
      en: '/expertise/[slug]/llms.txt',
    },
    '/erfolgreich': {
      de: '/erfolgreich',
      en: '/success',
    },
    '/jobs': '/jobs',
    '/jobs/[slug]': '/jobs/[slug]',
    '/datenschutz': {
      de: '/datenschutz',
      en: '/privacy',
    },
    '/impressum': {
      de: '/impressum',
      en: '/legal',
    },
    '/kontakt/projekt': {
      de: '/kontakt/projekt',
      en: '/contact/project',
    },
    '/kontakt/projekt/dankeschoen': {
      de: '/kontakt/projekt/dankeschoen',
      en: '/contact/project/thank-you',
    },
  },
})

// Lightweight wrappers around Next.js' navigation APIs
// that will consider the routing configuration
export const {
  Link,
  redirect,
  usePathname,
  useRouter,
  getPathname,
  permanentRedirect,
} = createNavigation(routing)

export type Pathname = Parameters<typeof getPathname>[0]['href']
